/**
 * TEMP — Cockpit Hub / hardware Back investigation logging.
 * Set to false and remove imports before merge.
 */
export const HARDWARE_BACK_DEBUG = true;

/** @param {...unknown} args */
export function hardwareBackLog(...args) {
  if (!HARDWARE_BACK_DEBUG) {
    return;
  }
  console.log("[HardwareBack]", ...args);
}
